import { render, staticRenderFns } from "./AppBooleanAnswer.vue?vue&type=template&id=c9ca376a&scoped=true"
import script from "./AppBooleanAnswer.vue?vue&type=script&lang=ts"
export * from "./AppBooleanAnswer.vue?vue&type=script&lang=ts"
import style0 from "./AppBooleanAnswer.vue?vue&type=style&index=0&id=c9ca376a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ca376a",
  null
  
)

export default component.exports